import { render, staticRenderFns } from "./OtherForms.vue?vue&type=template&id=7ebfe042"
import script from "./OtherForms.vue?vue&type=script&lang=js"
export * from "./OtherForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports